import { TilesServiceEnum } from "@ryde/shared";

/** Fewer than this many available providers → nothing to switch between, hide the layer control. */
export const MIN_SELECTABLE_LAYERS = 2;

/** Base-tile options — names mirror the Leaflet `LayersControl.BaseLayer` labels (hardcoded there too). */
export const LAYER_OPTIONS: { service: TilesServiceEnum; label: string }[] = [
  { service: TilesServiceEnum.OSM, label: "OpenStreet" },
  { service: TilesServiceEnum.Google, label: "Google" },
  { service: TilesServiceEnum.Mapbox, label: "Mapbox" },
];
